import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrManageContentButton } from '@bloomreach/react-sdk';
import { getDisplayName } from '@grandvisionhq/utils';

/**
 * This HoC requires the passed component to have a content object on its props
 * This means when used in combination with withBloomreachData hoc, this hoc should come after
 *  compose(withBloomreachData, withEditableContent)
 */ function withEditableContent(Component) {
    const displayName = getDisplayName(Component);
    const WithEditableContent = (props)=>{
        if (!props.content || !props.content.document) {
            return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props));
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            style: {
                position: 'relative'
            }
        }, /*#__PURE__*/ React.createElement(BrManageContentButton, {
            content: props.content.document
        })), /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props)));
    };
    WithEditableContent.displayName = `WithEditableContent(${displayName})`;
    return WithEditableContent;
}

export { withEditableContent };
//# sourceMappingURL=with-editable-content.js.map
